var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3a1542291a5b9dcdc16906c31328ca53.js').default;export default
        Object.assign({}, scope_0 )
    